import { LocationPickerSelection } from '../../models';
import { IUserInfo, Region, Location } from '../../models';
import { UserService } from '../../services';
import { SelectionItem } from 'ng2-material-components/ng2-material-components';
import { Component, AfterViewInit, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';


@Component({
  selector: 'location-picker',
  template: require('./location-picker.component.pug'),
})
export class LocationPickerComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() showLocations: boolean = true;
  @Input() allowSelectMultipleLocations = true;
  @Input() fg: FormGroup;
  @Input() regionsFiltered: Region[];
  @Input() regionSelected: Region = new Region();
  @Input() locationSelected: Location = new Location();
  @Output() applyLocationSelected = new EventEmitter<LocationPickerSelection>();
  @Output() filterReady = new EventEmitter();

  regions: SelectionItem[];
  locations: SelectionItem[];

  private _user: IUserInfo;
  private _userSubs: Subscription;
  private _regionSubs: Subscription;

  constructor(private _userSvc: UserService) { }

  ngOnInit() {
    this._userSubs = this._userSvc.user$
      .do(user => this._user = user)
      .subscribe(user => this._refreshRegions(user));
  }

  ngAfterViewInit() {
    this._regionSubs = this.fg.controls['region'].valueChanges
      .subscribe(regionId => this._updateLocations(regionId));
  }

  ngOnDestroy() {
    this._userSubs.unsubscribe();
    this._regionSubs.unsubscribe();
  }

  getSelection(): LocationPickerSelection {
    let value = this.fg.value;
    let region = this.regionsFiltered.find(r => r.id === +value.region);
    let locationIds =  value.location ? value.location.split(',') : [];
    let locations = [];

    if (locationIds.length > 0) {
      locations = region.locations.filter(l => locationIds.indexOf(l.id.toString()) !== -1);
    } else if (region) {
      locations = region.locations;
    } else {
      locations = this._user.locations;
    }
    return new LocationPickerSelection(region, locations);
  }

  private _refreshRegions(user: IUserInfo) {
    if (!user || !user.regions) {
      this.regions = null;
      return;
    }
    this.regions = user.regions.map(region => {
      return new SelectionItem(region.id, region.name, region.id === this.regionSelected.id);
    });

    if (this.regionsFiltered) {
      this.regions = this.regionsFiltered.map(region => {
        return new SelectionItem(region.id, region.name, region.id === this.regionSelected.id);
      });
    } else {
      this.regionsFiltered = this._user.regions;
    }

    setTimeout(() => this.filterReady.emit(), 100);

  }

  private _updateLocations(regionId: number) {
    if (!regionId) { return; }
    this.fg.controls['location'].setValue('');
    this.locations = this.regionsFiltered
      .find(region => region.id === +regionId).locations
      .map(location => new SelectionItem(location.id, location.name, location.id === this.locationSelected.id));
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/location-picker/location-picker.component.ts